import * as generalHelper from "../../../helpers/generalHelper";
import * as menuConstants from "../../../constants/menuConstants";
import * as methods from "../../../constants/serverMethods";
import * as navigationActions from "../../../actions/navigationActions";
import * as objectTypes from "../../../constants/objectTypes";
import * as optionHelper from "../../../helpers/optionHelper";
import * as optionsConstants from "../../../constants/optionsConstants";
import * as propertyConstants from "../../../constants/propertyConstants";
import * as settingsActions from "../../../actions/optionActions";
import * as spectroActions from "../../../actions/colorActions";
import * as tableHelper from "../../../helpers/tableHelper";
import * as universalObjectActions from "../../../actions/universalObjectActions";

import { AppState } from "../../../reducers";
import { Color } from "../../../types/color";
import { ColorData } from "../../../types/colorData";
import { Dispatch } from "redux";
import { Fandeck } from "../../../types/fandeck";
import { MasterColorScene } from "../../../components/scenes/master/MasterColorScene";
import { MenuItem } from "../../../types/menu";
import { Product } from "../../../types/product";
import { ServerRequest } from "../../../types/serverRequest";
import { Unit } from "../../../types/unit";

import { connect } from "react-redux";

export type PropsType = Readonly<{
    menuScene: MenuItem | null;
    activeBookmark: string | null;
    fandeckList: Array<Fandeck>;
    fandeckActiveList: Array<Fandeck>;
    fandeckLoading: boolean;
    productList: Array<Product>;
    productActiveList: Array<Product>;
    colorTableConstant: string;
    colorDetailTableConstant: string;
    colorList: Array<Color>;
    colorActiveList: Array<Color>;
    colorModalActiveList: Array<Color>;
    colorLoading: boolean;
    colorColumnOrder: Array<propertyConstants.Property>;
    colorColumnVisibility: Record<propertyConstants.Property, boolean>;
    colorColumnWidth: Record<propertyConstants.Property, number>;
    colorOffset: number;
    colorPage: number;
    colorRowCount: number;
    colorRowCountCustom: boolean;
    colorSceneTableSize: Record<string, any> | null;
    colorSearch: string | null;
    colorSearchParams: Record<propertyConstants.Property, string>;
    colorShowFilterRow: boolean;
    colorShowGlobalSearch: boolean;
    colorSortingAsc: boolean;
    colorSortingCriterion: propertyConstants.Property | null;
    colorTotalCount: number | null;
    formulasLoading: boolean;
    formulaColorantTableConstant: string;
    formulaColorantColumnOrder: Array<propertyConstants.Property>;
    formulaColorantColumnVisibility: Record<propertyConstants.Property, boolean>;
    formulaColorantColumnWidth: Record<propertyConstants.Property, number>;
    unitList: Array<Unit>;
    activeUnit: Unit | null;
    optionUseLargoNames: boolean;
    optionUseTmcNames: boolean | null;
    sceneLayout: string | null;
    sessionUuid: string | null;
    urlRest: string;
}>;

export type DispatchType = Readonly<{
    setActive(objectType: objectTypes.ObjectType, items: Array<any>): any;
    setActiveBookmark(key: string): void;
    setOptions(options: Array<{ key: string; object?: string; value?: any; locked?: boolean }>, save: boolean): any;
    setSearch(objectType: objectTypes.ObjectType, search: string, column?: string): any;
    updateColorData(objectType: objectTypes.ObjectType, colorData: Array<ColorData>, spectroTypeId: any): void;
}>;

const mapStateToProps = (state: AppState): PropsType => ({
    menuScene: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_MASTER_COLORS
    ),
    activeBookmark: state.navigation.activeBookmark,
    fandeckList: state.fandeck.masterList,
    fandeckActiveList: state.fandeck.masterActiveList,
    fandeckLoading: state.server.requests.some(
        (request: ServerRequest) => request.method === methods.METHOD_GET_ALL_MASTER_SIMPLE_FANDECKS
    ),
    productList: state.product.masterList,
    productActiveList: state.product.masterActiveList,
    colorTableConstant: menuConstants.TABLE_MASTER_COLORS,
    colorDetailTableConstant: menuConstants.TABLE_MASTER_COLORS_DETAIL,
    colorList: state.color.masterList,
    colorActiveList: state.color.masterActiveList,
    colorModalActiveList: state.color.masterModalActiveList,
    colorLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_MASTER_COLORS_IN_FANDECKS_BY_FANDECK ||
            request.method === methods.METHOD_DELETE_MASTER_COLOR_IN_FANDECK
    ),
    colorColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorOffset: state.color.masterOffset,
    colorPage: state.color.masterPage,
    colorRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorSceneTableSize: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_TABLE_SIZE,
        menuConstants.PAGE_MASTER_COLORS
    ),
    colorSearch: state.color.masterSearch,
    colorSearchParams: state.color.masterSearchParams,
    colorShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_MASTER_COLORS
    ),
    colorSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_MASTER_COLORS
        )
    ),
    colorSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_MASTER_COLORS
        )
    ),
    colorTotalCount: state.color.masterCount,
    formulasLoading: state.server.requests.some(
        (request: ServerRequest) => request.method === methods.METHOD_GET_MAIN_FORMULAS_FOR_COMBINATION
    ),
    formulaColorantTableConstant: menuConstants.TABLE_MASTER_FORMULA_COLORANTS,
    formulaColorantColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_MASTER_FORMULA_COLORANTS
    ),
    formulaColorantColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_MASTER_FORMULA_COLORANTS
    ),
    formulaColorantColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_MASTER_FORMULA_COLORANTS
    ),
    unitList: state.color.unitAllList,
    activeUnit:
        state.color.unitAllList.find(
            (item: Unit) =>
                optionHelper.getValueFromOptionDictionaryByKey(
                    state.login.options,
                    optionsConstants.OPTION_FORMULA_COLORANT_UNIT
                ) === item[propertyConstants.PROPERTY_NAME]
        ) ?? null,
    optionUseLargoNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_LARGO_NAMES
    ),
    optionUseTmcNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_TMC_NAMES
    ),
    sceneLayout: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_LAYOUT,
        menuConstants.PAGE_MASTER_COLORS
    ),
    sessionUuid: state.software.sessionUuid,
    urlRest: state.server.urlRest
});
const mapDispatchToProps = (dispatch: Dispatch): DispatchType => ({
    setActive: (objectType: objectTypes.ObjectType, items: Array<any>): any =>
        dispatch(universalObjectActions.setActiveItems(objectType, items)),
    setActiveBookmark: (key: string): any => dispatch(navigationActions.setActiveBookmark(key)),
    setOptions: (options: Array<{ key: string; object?: string; value?: any; locked?: boolean }>, save: boolean): any =>
        dispatch(settingsActions.setDictionaryOptions(null, options, save)),
    setSearch: (objectType: objectTypes.ObjectType, search: string | null, column?: string): any =>
        dispatch(universalObjectActions.setSearch(objectType, search, column)),
    updateColorData: (objectType: objectTypes.ObjectType, colorData: Array<ColorData>, spectroTypeId: any): any =>
        dispatch(spectroActions.updateColorData(objectType, colorData, spectroTypeId))
});

export const MasterColorSceneContainer = connect(mapStateToProps, mapDispatchToProps)(MasterColorScene);
